import { render } from "./UiDialog.vue?vue&type=template&id=278a4870"
import script from "./UiDialog.vue?vue&type=script&lang=js"
export * from "./UiDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__